import React from 'react';
import { Drawer } from '@silverfort/sf-components';
import {SaveExposuresConfigPayload, StaticExposureCustomConfig} from '../types';
import StaticExposureConfigurationContent from './StaticExposureConfigurationContent';

export interface SimpleExposureConfigurationDrawerProps {
    exposureConfig: StaticExposureCustomConfig;
    isOpen: boolean;
    onClose: () => void;
    onSave: (exposureConfig: SaveExposuresConfigPayload) => void;
    isSaving: boolean;
}

const StaticExposureConfigurationDrawer: React.FC<SimpleExposureConfigurationDrawerProps> = ({
    isOpen,
    onClose,
    exposureConfig,
    onSave,
    isSaving,
}) => {
    return (
        <Drawer
            open={isOpen}
            onClose={onClose}
            title={`Configure ${exposureConfig?.displayName}`}
            anchor="right"
            contentClassName="p-[0px] !p-[0px] w-[900px] max-w-[900px]"
            footerActionTitle="Close"
            headerClassName="p-[0px] w-[900px] max-w-[900px]"
            headerDescription={exposureConfig?.description}
            headerTitle={exposureConfig?.displayName}>
            {exposureConfig && (
                <div className="flex flex-col w-[900px] bg-sf-white overflow-hidden">
                    <div className="flex gap-2 flex-col px-6 py-4 items-start border-b border-gray-200">
                        <span className="text-13 sf-gray-600">Categories</span>
                        <span className="p-1 text-12 sf-gray-800 border border-gray-100 font-medium rounded-sm w-auto">
                            { exposureConfig?.category}
                        </span>
                    </div>

                    <StaticExposureConfigurationContent
                        config={exposureConfig}
                        onSave={onSave}
                        isSaving={isSaving}
                    />
                </div>
            )}
        </Drawer>
    );
};

export default StaticExposureConfigurationDrawer;
